import tpv from './base';
import { apiGetter } from '@synergycms_core/utils/api';


export default class CARDNET extends tpv {
    environment = 'stage';

    constructor(environment, reservation, hotel, tpvPaymentStatus, setReservationPayed, showConfirmation, showErrorNotification) {
        super();
        this.environment = environment;
        if (
            tpvPaymentStatus === 'CARDNET:OK' &&
            reservation.get('status') === 'confirmed' &&
            reservation.getIn(['payment', 'payform_code']) === 'op'
        ) {
            showConfirmation(reservation, hotel);
        } else if (tpvPaymentStatus === 'CARDNET:ERROR') {
            showErrorNotification('ha ocurrido un error con el proceso de pago online, por favor, vuelva a intentarlo');
        }
    }

    initialize = (hotel, reservation, currencyCode, showErrorNotification) => {
        this.prepayToken = false;
        if (
            reservation.get('status') === 'confirmed' &&
            reservation.getIn(['payment', 'payform_code']) === 'op' &&
            reservation.getIn(['payment', 'state']) === 'pending'
        ) {
            showErrorNotification('ha ocurrido un error con el proceso de pago online, por favor, vuelva a intentarlo');
        }

        const amountPromoPaid = reservation.getIn(['payment', 'amount_promo_paid'], 0);
        let amountToPay = reservation.get('total_price_tax') - amountPromoPaid;

        return this.getFormData(
            hotel.get('code'),
            amountToPay,
            reservation.get('tracking_id'),
            hotel.get('id'),
            encodeURIComponent(document.URL),
            currencyCode)
            .then(result => {
                if (result && result.session && result.form_url) {
                    this.queryObj = { SESSION: result.session };
                    this.api = apiGetter(result.form_url, 'form');
                } else {                    
                    console.error('Cardnet error:', result.error);
                }
            })
            .catch(error => {
                console.error('Cardnet error:', error);
            });
    };

    // https://syn2pre.booking-channel.com/api/hotels/[notel_id]/cardnet_payments
    getFormData = (hotelCode, price, trackingId, hotelId, redirectUrl, currency) => {
        const domain = process.env.NODE_ENV != "production" ? 'https://syn2pre.booking-channel.com' : 'https://synergy.booking-channel.com';
        const url = domain + '/api/hotels/' + hotelId + '/cardnet_payments';
        const data = {
            currency: currency,
            amount: price,
            hotel_code: hotelCode,
            tracking_id: trackingId,
            location: redirectUrl
        };

        return this.query(url, 'POST', data);
    };

    validatePayment = () => {
        if (typeof this.queryObj !== "undefined") {
            this.api.post(this.queryObj);
        } else {
            window.location.replace(document.URL);
        }
    };
}
